import { throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  router = inject(Router);

  // Arrow properties so `this` is preserved when passed to RxJS catchError(...)
  handleError = (error: HttpErrorResponse | any) => {
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      const body = this.parseErrorBody(error.error);
      console.log(error);
      if(error.status === 403 && error.error.errorCode === "subscription_required") {
        this.router.navigate(['/signup/payment'])
        return;
      }
      else if (body?.developerMessage) {
        errMsg = body.developerMessage;
      } else if (body?.message) {
        errMsg = body.message;
      } else if (typeof body === 'string' && body.trim()) {
        errMsg = body;
      } else {
        errMsg = `${error.status} - ${error.statusText || error.message || 'Request failed'}`;
      }
    } else if (typeof error === 'string') {
      errMsg = error;
    } else {
      errMsg = error?.message ? error.message : String(error);
    }

    console.error(errMsg, error);
    return throwError(() => errMsg);
  };

  handleAuth0Error = (error: HttpErrorResponse | any) => {
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      const body = this.parseErrorBody(error.error);
      if (body?.error_description) {
        errMsg = body.error_description;
      } else if (body?.message) {
        errMsg = body.message;
      } else if (body?.description) {
        errMsg = body.description;
        if (body.description === 'Invalid sign up' && body.code === 'invalid_signup') {
          errMsg = 'Account already created for this email. ' +
            'If you believe this is in error, please reach out to support@muchsmarter.com';
        }
      } else {
        errMsg = 'Undefined authentication error.';
      }
    } else if (typeof error === 'string') {
      errMsg = error;
    } else {
      errMsg = 'Undefined authentication error.';
    }
    console.error(errMsg);
    return throwError(() => errMsg);
  };

  /**
   * HttpClient may give error.error as a parsed object or as a raw JSON string.
   * Never call JSON.parse on an object (that yields "[object Object]" SyntaxError).
   */
  private parseErrorBody(errorBody: unknown): any {
    if (errorBody == null) {
      return null;
    }
    if (typeof errorBody === 'object') {
      return errorBody;
    }
    if (typeof errorBody === 'string') {
      try {
        return JSON.parse(errorBody);
      } catch {
        return errorBody;
      }
    }
    return errorBody;
  }
}
